import { useQuery } from "@tanstack/react-query";

import { LegalProceedingService } from "@/services/legalProceeding";
import { legalProceedingsQueryKey } from "../usePaginatedLegalProceedingsQuery";

export const monitoredCountQueryKey = [...legalProceedingsQueryKey, "monitoredCount"];

/**
 * The TRUE billed monitoring count for the company (active + paused trackings),
 * from GET /legalProceedings/monitored/count. This is the "you monitor N
 * processes" number used by the retention banners — NOT the paginated list's
 * totalResults, which counts imported proceedings rather than billed trackings.
 */
export const useMonitoredCount = () => {
  return useQuery({
    queryKey: monitoredCountQueryKey,
    queryFn: async () => await LegalProceedingService.getMonitoredCount(),
    retry: false,
  });
};
